"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidFlexAlignment = void 0;
var FluidFlexAlignment;
(function (FluidFlexAlignment) {
    FluidFlexAlignment["START"] = "start";
    FluidFlexAlignment["CENTER"] = "center";
    FluidFlexAlignment["END"] = "end";
    FluidFlexAlignment["STRETCH"] = "stretch";
    FluidFlexAlignment["BASELINE"] = "baseline";
})(FluidFlexAlignment = exports.FluidFlexAlignment || (exports.FluidFlexAlignment = {}));
